import { Box } from '@chakra-ui/react';

import styles from './styles.module.css';

const StatusBadge = ({ label, bg, color }) => (
  <Box className={styles['status-badge__container']} style={{ backgroundColor: bg, color }}>
    {label}
  </Box>
);

export default StatusBadge;
